import React from 'react';
import WebQuestionPanel from '../../components/question/WebQuestionPanel';
import Pagination from 'react-ultimate-pagination-material-ui';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import LoggedInPage from '../../views/core/LoggedInPage';
import $ from 'jquery';


$.fn.inView = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $("#questionsParent").scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};
	
class ViewSolution extends LoggedInPage {
	
  constructor(props) {
  	super(props);
  	
  	this.state = { currentScrollIndex: 1};
  	
  	this.onPageChange = this.onPageChange.bind(this);
  	//this.scrollFinished = this.scrollFinished.bind(this);
  	this.isScrollPreset = false;
  }
  componentDidMount(){	  
	var me = this;
	var scrollTimer = -1;
	$("#questionsParent").scroll(function(event) {
		if(me.isScrollPreset == false){
			var element = document.getElementById("qindex-"+me.state.currentScrollIndex);
			if(me.state.currentScrollIndex != 0 && $(element).inView() == false){
				me.setState({currentScrollIndex:0});
			}			
		}
		
		if (scrollTimer != -1)
            clearTimeout(scrollTimer);
				
        scrollTimer = setTimeout(function(){        	
        	me.isScrollPreset = false;
        }, 500);        
    });	
  }  
  onPageChange(page){
		//console.log(page);
	  	this.isScrollPreset = true;
		this.setState({currentScrollIndex:page});
		var element = document.getElementById("qindex-"+page);
		element.scrollIntoView({behavior: 'smooth', block: "start"});
  }
  render() {	
	  var me = this;
	
    return (
			 <MuiThemeProvider>
				{/* marked questions hidden -- kamaraj */}
				{/*<div className="mques"><span><i className="material-icons ">star</i></span> {this.rb("home.markedquestions")} </div>*/}
				<div id="questionsParent">
					{this.props.questions.map(function (eachques, index) {
						eachques["testId"] = me.props.testId;
						eachques["topicSubTopicMapId"] = me.props.topicSubTopicMapId;
						return <div key={index} id={"qindex-"+eachques.questionNo}><WebQuestionPanel qno={eachques.questionNo} ga={me.props.ga} qdata={eachques} existingRatingObj={me.props.existingRatingObj} accessId={me.props.accessId} classId={me.props.classId} recomLocked={me.props.recomLocked}/>
						</div>;
					})}
				</div>
				<div className="col-12 text-center paginationParent">
				      <Pagination
				      currentPage={this.state.currentScrollIndex}
				      totalPages={this.props.questionTypeCount}
				      boundaryPagesRange={5}
				      siblingPagesRange={5}
				      hidePreviousAndNextPageLinks={true}
				      hideFirstAndLastPageLinks={true}
				      hideEllipsis={true}
				      onChange={this.onPageChange}
				    />
				</div>
			</MuiThemeProvider>
		);
  }
}

export default ViewSolution;



// WEBPACK FOOTER //
// ./src/views/scorecard/ViewSolution.js